import { render, staticRenderFns } from "./BaseFileName.vue?vue&type=template&id=1a731758&scoped=true&"
import script from "./BaseFileName.vue?vue&type=script&lang=js&"
export * from "./BaseFileName.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileName.vue?vue&type=style&index=0&id=1a731758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a731758",
  null
  
)

export default component.exports